import React from 'react';
import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

import { FormInput, FormInputProps } from '@occc-app/Offer/components/FormInput';
import { UnitedStates } from '@occc-app/lib/constants';
import { AutocompleteOption, AutocompleteProps, Autocomplete } from '@occc-app/design-system';

import {
  autocompleteLengthValidation,
  withAutocompleteValueValidation,
} from '../../validatableComponent';
import { actions, State } from '../redux';

type LocationsValidateWith = Pick<State['locationInState'], 'states'>;

type Actions = typeof actions;
type ComponentState = State['locationInState'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  constraintConfigurationUpdate: Actions['constraintConfigurationUpdate'];
  editMode?: boolean;
  fieldDisabled: (field: Fields) => boolean;
  states?: string[];
};
const LocationInStateConfiguration: React.FC<Props> = (props) => {
  const { constraintConfigurationUpdate, fieldDisabled, editMode, states } = props;

  const statesData =
    UnitedStates &&
    UnitedStates.map((state) => ({
      value: state.id,
      label: state.text,
    }));

  const selectedStates =
    statesData && statesData.filter((selectedState) => states.includes(selectedState.value));

  const handleChange = (event: React.ChangeEvent<{}>, selectOptions: AutocompleteOption[]) => {
    constraintConfigurationUpdate(
      'locationInState',
      'states',
      selectOptions.map((selectOption) => selectOption.value),
    );
  };

  const LocationSelect = editMode
    ? withAutocompleteValueValidation<AutocompleteProps, LocationsValidateWith>(
        Autocomplete,
        autocompleteLengthValidation,
      )
    : Autocomplete;

  const renderInput = (
    params: AutocompleteRenderInputParams,
    inputProps?: FormInputProps,
  ): React.ReactNode => (
    <FormInput
      {...params}
      label='Location Constraint'
      placeholder='Select US state(s)'
      {...(inputProps || {})}
    />
  );

  return (
    <LocationSelect
      multiple={true}
      onChange={handleChange}
      options={statesData}
      value={selectedStates}
      disabled={fieldDisabled('states')}
      renderInput={renderInput}
    />
  );
};

export { LocationInStateConfiguration };
